import React, { Component } from 'react';
import { Modal, Button, Table } from 'antd';
import API_URL from '../../../../common/url';
import AjaxRequest from '../../../../common/AjaxRequest';

class PMRefuseReson extends Component {
    state = {
        visible: false,
        loading: false,
        data: [], 
    }

    show = (id) => {
        this.setState({ visible: true }, () => {
            this.loadData(id);
        });
    }

    hide = () => {
        this.setState({ visible: false });
    };

    loadData = staffHandoverId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.queryHandoverRejectLog,
            data: { staffHandoverId },
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data,
                });
            },
            errorResult: () => {
                this.setState({ loading : false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    getColumns = () => [{
        title: '打回时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width:120
    }, {
        title: '打回原因',
        dataIndex: 'remark',
        key: 'remark',
        width:200
    }, {
        title: '操作人',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width:80
    }]

    render() {
        const {visible, loading, data } = this.state;
        return (
            <Modal
                title={'查看打回原因'}
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal"
                width="500px"
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button key="back" type="primary" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <Table
                        columns={this.getColumns()}
                        dataSource={data}
                        pagination={false}
                        loading={loading}
                        bordered
                    />
                </div>
            </Modal>
        );
    }
}

export default PMRefuseReson;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/PMRefuseReson.js